import React, { useState } from 'react';
import { researchProjects } from '../data/projects';
import { chapters } from '../data/chapters';
import ResearchCard from '../components/ResearchCard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProjectFilter from '../components/ProjectFilter';

const ResearchPage = () => {
  const [selectedIndustry, setSelectedIndustry] = useState('All');

  // Create industry list from chapter's projects
  const industries = [
    'All',
    ...Array.from(new Set(
      researchProjects.flatMap(p =>
        Array.isArray(p.industry) ? p.industry : [p.industry]
      )
    ))
  ];

  // Filter by industry within the chapter's projects
  const filteredProjects =
    selectedIndustry === 'All'
      ? researchProjects
      : researchProjects.filter(p =>
          Array.isArray(p.industry)
            ? p.industry.includes(selectedIndustry)
            : p.industry === selectedIndustry
        );

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
      <Header />
      <main style={{ padding: '6rem 2rem 3rem', maxWidth: '1200px', margin: '0 auto' }}>
        <h1 className='huge-title'>Our Research Projects</h1>

        {/* Live Count */}
        <p className='subtitle'>
          <strong>{filteredProjects.length} / {researchProjects.length}</strong> projects shown
        </p>
        
        {/* Industry Filter Buttons */}
        <ProjectFilter
          options={industries}
          selected={selectedIndustry}
          onSelect={setSelectedIndustry}
        />

        {/* Cards */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center' }}>
          {filteredProjects.map(project => {
            const chapterSlug = chapters.find(c => c.name === project.chapter)?.slug;

            return (
              <ResearchCard
                key={project.slug}
                slug={project.slug}
                title={project.title}
                description={project.overview}
                status={project.status}
                people={project.people}
                group={project.group}
                advisors={project.advisors}
                orgs={project.orgs || []}
                chapterSlug={chapterSlug}
                chapter={project.chapter}
              />
            );
          })}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ResearchPage;
